<template>
  <div class="ImagesObjects">
    <draggable
      class="image"
      v-for="item in images"
      :key="item.key"
      :x="item.x"
      :y="item.y"
      :w="item.w || 60"
      :h="item.h || 60"
      :angle="item.angle || 0"
      :ratio="Number(tableScale)"
      :resizable="true"
      :lock="!tableEdit"
      @change="(x, y, w, h, angle) => onChange(item.key, x, y, w, h, angle)"
    >

      <img :src="src(item.imageKey)" alt="" draggable="false">
      <faicon icon="clone" v-if="tableEdit" class="clone" @mousedown.prevent="duplicate(item.key)" />
      <span v-if="tableEdit && item.pinnedInScene" class="pin" @mousedown.prevent="pin(item.key, false)"><faicon icon="thumbtack" /><span class="text">シーン保存・切替の対象から外す</span></span>
      <span v-if="tableEdit && !item.pinnedInScene" class="pin" @mousedown.prevent="pin(item.key, true)"><faicon icon="chess-rook" /><span class="text">シーン保存・切替の対象にする</span></span>
      <faicon icon="times" v-if="tableEdit" class="remove" @mousedown.prevent="remove(item.key)" />

    </draggable>
  </div>
</template>

<script>
import draggable from '../common/draggable'

export default {
  components: { draggable },
  computed: {
    images() {
      return this.$store.getters['imageObjectList/$items']
    },
    tableScale() {
      return this.$store.getters['local/tableScale']
    },
    tableEdit() {
      return this.$store.getters['local/tableEdit']
    },
    src() {
      return this.$store.getters['images/getSrc']
    }
  },
  methods: {
    onChange(key, x, y, w, h, angle) {
      return this.$store.dispatch('imageObjectList/setPos', { key, data: { x, y, w, h, angle } })
    },
    duplicate(key) {
      this.$store.commit('imageObjectList/$checkout', key)
      return this.$store.dispatch('imageObjectList/$duplicate', key)
    },
    remove(key) {
      return this.$store.dispatch('imageObjectList/$remove', key)
    },
    pin(key, pinnedInScene) {
      return this.$store.dispatch('imageObjectList/setPin', { key, data: { pinnedInScene } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ImagesObjects {
  /* position: absolute;
  left: 50%;
  top: 50%; */
  /* transform: translate(50%, 50%);
  width: 0;
  height: 0; */
  transform: translate(0);
  width: 100%;
  height: 100%;
  /*z-index: 10;*/
  color: #ccc;
}
.image .imageSelect {
  position: absolute;
  bottom: 100%;
}
.image img {
  width: 100%;
  height: 100%;
  /* box-shadow: 0 0 20px rgba(0, 0, 0, 0.8); */
}
.remove, .clone {
  /* border: 1px solid #fff; */
  position: absolute;
  width: 10px;
  height: 10px;
  /* background: rgba(0, 0, 0, 0.2); */
  color: #fff;
  cursor: pointer;
  /* visibility: hidden; */
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.8));
}
.pin {
  font-size: 10px;
  position: absolute;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  /* background: rgba(0, 0, 0, 0.2); */
  color: #fff;
  cursor: pointer;
  /* visibility: hidden; */
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.8));
}
.pin span {
  margin-left:3px;
}
.remove {
  top: 0;
  right: 0;
}
.clone {
  bottom: 0;
  left: 0;
}
.pin {
  top: 0;
  left: 0;
}
.image:hover .remove,
.image:hover .clone,
.image:hover .pin {
  visibility: visible;
}
</style>
